import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HttpService, API, swal, Title, DateFormat, toast, Messages } from '../../config/react'
import DataTable from 'react-data-table-component'
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars'
import '../../assests/fonts/mdi/css/material.css'
const Appointment = () => {
  const [AppointmentList, setAppointment] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [AppointmentUsers, setAppointmentUsers] = useState([])
  const [totalRows, settotalRows] = useState()
  const [ShowFilters, setShowFilters] = useState(false)
  const [ServiceTypeList] = useState(['In-Store Appointment', 'Virtual Appointment'])
  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    assignee: 0,
    status: '',
    service_type: '',
    booking_from: '',
    booking_to: '',
    assignee_name: '',
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const columns = [
    {
      name: 'Booking Date',
      sortable: true,
      wrap: true,
      sortField: 'booking_date',
      selector: (row) => <DateFormat value={row.booking_date}></DateFormat>
    },
    {
      name: 'Service',
      wrap: true,
      selector: (row) => (
        <div>
          <label>{row.service_type}</label>
        </div>
      )
    },
    {
      name: 'Name',
      selector: (row) => <label>{row.name}</label>,
      wrap: true
    },
    {
      name: 'E-Mail',
      wrap: true,
      selector: (row) => <label> {row.email} </label>
    },
    {
      name: 'Contact No',
      wrap: true,
      selector: (row) => row.contact_number
    },
    {
      name: 'Status',
      selector: (row) => row.status
    },
    // {
    //   name: 'Assignee',
    //   selector: (row) => row.assignee
    // },
    {
      name: 'Created Date',
      sortable: true,
      wrap: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => {
        let showReviewButton = false

        if (row.booking_date) {
          const bookingDate = new Date(
            String(row.booking_date).replace(' ', 'T') +
              (String(row.booking_date).endsWith('Z') ? '' : 'Z')
          )

          const now = new Date()

          // Hide if appointment date/time has already passed
          const isPastAppointment = bookingDate < now

          // Check if booking time is after 5:30 PM
          const hours = bookingDate.getUTCHours()
          const minutes = bookingDate.getUTCMinutes()
          const isPastFiveThirty = hours > 17 || (hours === 17 && minutes > 30)

          showReviewButton = !isPastAppointment && isPastFiveThirty && !row.is_confirmed
        }

        const handleConfirm = (id) => {
          swal({
            title: 'Review Appointment',
            text: 'Do you want to Confirm or Reject this appointment?',
            buttons: {
              confirm: {
                text: 'Confirm',
                value: 'confirm',
                className: 'btn btn-primary'
              },
              reschedule: {
                text: 'Reject',
                value: 'reschedule',
                className: 'btn btn-primary'
              }
            }
          }).then((value) => {
            if (value === 'reschedule') {
              // TODO: call your accept API here
              const param = {
                id: id,
                base_url: process.env.REACT_APP_FRONTEND_URL,
                is_reschedule: true
              }
              HttpService.postApi(API.ReviewAppointment, param).then((response) => {
                console.log(response)
                GetAppointmentList()
              })
              // e.g. acceptAppointment(id)
              console.log(id)
              toast.success(Messages.AppointmentRejected)
            }
            if (value === 'confirm') {
              const param = {
                id: id
              }
              HttpService.postApi(API.ReviewAppointment, param).then((response) => {
                console.log(response)
                GetAppointmentList()
                toast.success(Messages.AppointmentConfirmed)
              })
            }
          })
        }

        return (
          <div className="action-btn">
            <Link
              to={'/Appointments/edit/' + row.id}
              className="text-dark"
              title="Edit"
            >
              <i
                className="fa fa-pencil-square-o"
                aria-hidden="true"
              ></i>{' '}
            </Link>

            {showReviewButton && (
              <span
                className="text-dark"
                title="Review Appointment"
                onClick={() => handleConfirm(row.id)}
              >
                <i
                  className="fa fa-hourglass-half"
                  aria-hidden="true"
                ></i>
              </span>
            )}
          </div>
        )
      }
    }
  ]

  useEffect(() => {
    document.title = Title.AppointmentTitle
    GetAppointmentList()
    GetAppointmentUsers()
    // GetServiceList()
  }, [CustomFilters])

  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }

  const handleInputChanges = (e, fieldName) => {
    e.preventDefault()
    if (fieldName === 'booking_date') {
      if (e.value !== null) {
        CustomFilters.booking_from = e.value[0]
        CustomFilters.booking_to = e.value[1]
      } else {
        CustomFilters.booking_from = ''
        CustomFilters.booking_to = ''
      }
    } else if (fieldName === 'assignee') {
      let assigneeName = AppointmentUsers.filter((item) => item.id === e.target.value)
      assigneeName = assigneeName.length > 0 ? assigneeName[0].name : ''
      CustomFilters[fieldName] = e.target.value
      CustomFilters.assignee_name = assigneeName
    } else {
      CustomFilters[fieldName] = e.target.value
    }
    setForceUpdate(!isForceUpdate)
  }
  // const GetServiceList = () => {
  //   const param = {
  //     id: null
  //   }
  //   HttpService.postApi(API.Getservices, param, false).then((response) => {
  //     setServiceTypeList(response.data.result[0])
  //   })
  // }
  const GetAppointmentUsers = () => {
    HttpService.getApi(API.GetAppointmentUsers).then((response) => {
      if (response.data.result) {
        const data = response.data.result[0]
        setAppointmentUsers(data)
      }
    })
  }
  const GetAppointmentList = () => {
    const param = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      assignee: CustomFilters.assignee,
      status: CustomFilters.status,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction,
      service_type: CustomFilters.service_type,
      booking_from:
        CustomFilters.booking_from !== ''
          ? new Date(CustomFilters.booking_from).toISOString().slice(0, 19).replace('T', ' ')
          : '',
      booking_to:
        CustomFilters.booking_to !== ''
          ? new Date(CustomFilters.booking_to).toISOString().slice(0, 19).replace('T', ' ')
          : ''
    }
    HttpService.postApi(API.GetAppointment, param).then((response) => {
      setAppointment(response.data.result[0])
      if (response.data.result[0].length > 0) settotalRows(response.data.result[0][0].total_count)
    })
  }

  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Service, Name, E-mail, Contact No."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, page: 1, search: e.target.value })}
      />
    )
  })
  const openFilterBox = () => {
    if (ShowFilters) {
      setShowFilters(false)
    } else {
      setShowFilters(true)
    }
  }
  const ClearFilter = (e) => {
    // e.preventDefault()
    setCustomFilters(DefaultFilters)
    setForceUpdate(!isForceUpdate)
    GetAppointmentList()
  }
  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.AppointmentTitle} </h3>
        <div className="btn-group ml-auto">
          <Link
            to="#"
            onClick={openFilterBox}
            className="btn btn-primary btn-fw rounded filter-btn mr-2"
          >
            {' '}
            Filters{' '}
          </Link>
        </div>
      </div>
      <div
        className={ShowFilters ? 'filter-bar d-block' : 'filter-bar'}
        id="filter-bar"
      >
        <div className="grid-margin w-100 stretch-card">
          <div className="card">
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label>Assignee</label>
                      <select
                        className="form-control"
                        name="assignee"
                        onChange={(e) => handleInputChanges(e, 'assignee')}
                        value={CustomFilters.assignee}
                      >
                        <option value="">Select</option>
                        {AppointmentUsers.map((item, index) => (
                          <option
                            value={item.id}
                            key={index}
                          >
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label>Status</label>
                      <select
                        className="form-control"
                        name="status"
                        onChange={(e) => handleInputChanges(e, 'status')}
                        value={CustomFilters.status}
                      >
                        <option value="">Select</option>
                        <option value="Pending">Pending</option>
                        <option value="In progress">In progress</option>
                        <option value="Successful">Successful</option>
                        <option value="Unsuccessful">Unsuccessful</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label>Service Type</label>
                      <select
                        className="form-control"
                        name="service_type"
                        onChange={(e) => handleInputChanges(e, 'service_type')}
                        value={CustomFilters.service_type}
                      >
                        <option value="">Select</option>
                        {ServiceTypeList.map((item, index) => (
                          <option
                            value={item}
                            key={index}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Booking Date</label>
                      <DateRangePickerComponent
                        onChange={(e) => handleInputChanges(e, 'booking_date')}
                      ></DateRangePickerComponent>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-12 pr-2 text-right">
                    <div className="btn-group ml-auto">
                      {/* <Link to="#" className="btn btn-primary btn-fw rounded mr-2" onClick={e => ClearFilter(e)}> Cancel </Link> */}
                      <span className="filter-result-repeat">
                        <a>
                          <button
                            type="button"
                            onClick={(e) => ClearFilter(e)}
                            className="btn btn-primary btn-fw rounded mr-2"
                          >
                            Clear All
                          </button>
                        </a>
                      </span>
                    </div>
                    <div className="btn-group">
                      <Link
                        to="#"
                        className="btn btn-dark btn-fw rounded mr-2"
                        onClick={(e) => GetAppointmentList(e)}
                      >
                        {' '}
                        Apply Filter{' '}
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={AppointmentList}
                  // progressPending={loading}
                  persistTableHead={true}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Appointment
